import React from "react";
import { Pencil, Trash, ArrowLeft } from "react-bootstrap-icons";

import TagsList from "components/Tags/TagsList"
import ValuesList from "components/Values/ValuesList"


function Details({
    item,
    onEditHandler,
    onDeleteHandler,
    onCloseHandler
}) {
    return (

        <div className="card container-height">

            <div className="card-header form-card-header-paddings no-background no-border">
                <div className="p-2">
                    <h3>{item.title}</h3>
                </div>
            </div>

            <div className="card-body form-card-body-paddings overflow-auto">
                <div className="flex-grow-1 overflow-auto">

                    <div className="mb-2">
                        <h5>Tags</h5>
                        <TagsList
                            items={item.tags}
                        />
                    </div>

                    <div className="mb-2">
                        <h5>Value</h5>

                        <ul className="list-group list-group-flush w-100">
                            {item.values.map((item, index) => {
                                return (
                                    <li
                                        key={index}
                                        className="list-group-item w-100 p-1"

                                    >
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '4px'
                                        }}>
                                            <div className="d-flex flex-column">
                                                <span>{item.name}{item.payload?.unit && <span className="text-muted small ms-1">({item.payload.unit})</span>}</span>
                                            </div>
                                            <span className="badge bg-secondary align-self-start">{item.type}</span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="card-footer form-card-footer-paddings border-top no-background">
                <div className="d-flex justify-content-between">
                    <div className="btn-group">
                        <button
                            className="btn btn-sm btn-outline-danger me-1"
                            onClick={() => onDeleteHandler(item.uid)}
                        >
                            <Trash size={16} />
                        </button>
                        <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => onEditHandler(item)}
                        >
                            <Pencil size={16} />
                        </button>
                    </div>

                    <button
                        type="button"
                        className="btn btn-secondary ms-auto"
                        onClick={(e) => {
                            e.preventDefault();

                            onCloseHandler(null);
                        }}
                    >
                        <ArrowLeft className="me-2" />
                        Back
                    </button>
                </div>
            </div>

        </div>

    );
};

export default Details;